import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

export default class B2bAPI {
  static async getBusinesses() {
    return (await $http.get(`/v1/b2b/businesses`)).data
  }

  static hasLogoChange(payload: any) {
    return payload && (payload.logo instanceof Blob || payload.remove_logo === 1 || payload.remove_logo === true)
  }

  static async create(payload: any) {
    if (payload && payload.logo instanceof Blob) {
      const formData = FormsService.convertObjectToFormData(payload)
      return (await $http.post('/v1/b2b/businesses', formData, { headers: FormsService.MULTIPART_HEADER })).data
    }
    return (await $http.post('/v1/b2b/businesses', payload)).data
  }

  static async getBusiness(id: number) {
    return (await $http.get(`/v1/b2b/businesses/${id}`)).data
  }

  static async update(id: number, payload: any) {
    if (B2bAPI.hasLogoChange(payload)) {
      const formData = FormsService.convertObjectToFormData({
        _method: 'PUT',
        ...payload,
      })
      return (await $http.post(`/v1/b2b/businesses/${id}`, formData, { headers: FormsService.MULTIPART_HEADER })).data
    }
    return (await $http.put(`/v1/b2b/businesses/${id}`, payload)).data
  }

  static async delete(id: number) {
    return (await $http.delete(`/v1/b2b/businesses/${id}`)).data
  }

  static async createBranch(businessId: number, payload: any) {
    return (await $http.post(`/v1/b2b/businesses/${businessId}/branches`, payload)).data
  }

  static async getBranches(businessId: number) {
    return (await $http.get(`/v1/b2b/businesses/${businessId}/branches`)).data
  }

  static async updateBranch(businessId: number, branchId: number, payload: any) {
    return (await $http.put(`/v1/b2b/businesses/${businessId}/branches/${branchId}`, payload)).data
  }

  static async deleteBranch(businessId: number, branchId: number) {
    return (await $http.delete(`/v1/b2b/businesses/${businessId}/branches/${branchId}`)).data
  }

  static async getItems(businessId: number) {
    return (await $http.get(`/v1/b2b/businesses/${businessId}`)).data
  }

  static async saveItems(businessId: number, items: any[], deletedItems: number[] = []) {
    return (await $http.post(`/v1/b2b/businesses/${businessId}/items`, { items, deleted_items: deletedItems })).data
  }

  static async getUsers(businessId: number, page = 1, perPage = 10) {
    const query = FormsService.prepareQueryString({ page, per_page: perPage }, true)
    return (await $http.get(`/v1/b2b/businesses/${businessId}/users?${query}`)).data
  }

  static async createUser(businessId: number, payload: any) {
    return (await $http.post(`/v1/b2b/businesses/${businessId}/users`, payload)).data
  }

  static async updateUser(businessId: number, userId: number, payload: any) {
    return (await $http.put(`/v1/b2b/businesses/${businessId}/users/${userId}`, payload)).data
  }

  static async deleteUser(businessId: number, userId: number) {
    return (await $http.delete(`/v1/b2b/businesses/${businessId}/users/${userId}`)).data
  }

  static async resetUserCredentials(businessId: number, userId: number, payload: any) {
    return (await $http.patch(`/v1/b2b/businesses/${businessId}/users/${userId}/reset-password`, payload)).data
  }

  static async settleCredit(businessId: number, payload: any) {
    return (await $http.post(`/v1/b2b/businesses/${businessId}/credit/settle`, payload)).data
  }

  static async adjustCreditLimit(businessId: number, payload: any) {
    return (await $http.put(`/v1/b2b/businesses/${businessId}/credit/limit`, payload)).data
  }

  static async getSettlementHistory(businessId: number) {
    return (await $http.get('/v1/b2b/reports/settlements', {
      params: { business_id: businessId },
    })).data
  }

  static async getReportsCreditLimitHistory(businessId: number) {
    return (await $http.get('/v1/b2b/reports/credit', {
      params: { business_id: businessId },
    })).data
  }

  static async getCreditLimitHistory(businessId: number) {
    return (await $http.get(`/v1/b2b/businesses/${businessId}/credit/limit-history`)).data
  }

  static async getOrdersReport(params: any) {
    return (await $http.get('/v1/b2b/reports/orders', { params })).data
  }

  static async getCreditReport(params: any) {
    return (await $http.get('/v1/b2b/reports/credit', { params })).data
  }

  static async exportOrdersReport(params: any) {
    const file = (await $http.get('/v1/b2b/reports/orders', {
      params: { ...params, export: 1 },
      responseType: 'blob',
    })).data
    saveAs(file, 'b2b-report.xlsx')
  }
}
